import axios from "axios";
import { domain } from "../../Links/Links";
import { getCookie } from "../../../App";

export async function addToShoppingCartRequest(
  setQuantityInShoppingCart,
  link,
  setAddToShoppingCartRequestStatus,
) {

  setAddToShoppingCartRequestStatus(true);

  console.log(link);

  const data = {
    link: link,
  };
  const response = await axios.post(
    domain + "/add_shopping_cart/",
    data,
    {
      withCredentials: true,
      headers: {
        "X-CSRFToken": getCookie("csrf_token"),
      },
    },
  );

  if (response.data.quantity_in_shopping_cart) {
    setQuantityInShoppingCart(response.data.quantity_in_shopping_cart);
    setAddToShoppingCartRequestStatus(false);
  }
}
